// shared-utils/src/addClassToElement.js

/**
 * Wait for an element to appear in the DOM, then add a class.
 *
 * @param {string} selector   CSS selector to poll for.
 * @param {string} className  Class to add when found.
 * @param {number} timeoutMs  Max wait time in ms (default 10000).
 * @returns {Promise<Element>}
 */
export function addClassToElement(selector, className, timeoutMs = 10000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    (function tick() {
      const el = document.querySelector(selector);
      if (el) {
        el.classList.add(className);
        resolve(el);
      } else if (Date.now() - start > timeoutMs) {
        console.warn(`[addClassToElement] timed out waiting for ${selector}`);
        reject(new Error(`Timeout waiting for ${selector}`));
      } else {
        setTimeout(tick, 100);
      }
    })();
  });
}
